import {
  teaserContentTypeValues,
  teaserLayoutLiveblogLinkValues,
  teaserLayoutLiveIndicatorStyleValues,
  teaserLayoutValues,
  teaserLayoutWhenScoreboardValues,
  teaserTimelineValues
} from "@webng/liveblog";
import z from "zod";
import {createPartialParser, removeNullValues, zBooleanWrapper} from "./utils";
import {ParsePayload} from "zod/v4/core";
import {preprocessSharedThemeConfiguration} from "./shared";

export function preprocessLiveblogTeaserThemeConfiguration(arg: unknown, ctx: ParsePayload): unknown {
  const step1 = removeNullValues(arg, ctx)
  return step1
}

export const rawLiveblogTeaserThemeConfigurationSchema = z.object({
  layout: z.enum(teaserLayoutValues).default("slider"),
  layoutLiveIndicatorStyle: z.enum(teaserLayoutLiveIndicatorStyleValues).default("badge"),
  layoutLiveblogLink: z.enum(teaserLayoutLiveblogLinkValues).default("bottom"),
  layoutTimeline: z.enum(teaserTimelineValues).default("time"),
  showTitle: zBooleanWrapper(true),
  styleInvertTime: zBooleanWrapper(),
  layoutWhenScoreboard: z.enum(teaserLayoutWhenScoreboardValues).default("scoreBoardEvents"),
  styleBgColor: z.string().default(""),
  styleBgColorDark: z.string().default(""),
  styleTextColor: z.string().default(""),
  styleTextColorDark: z.string().default(""),
  styleTextMutedColor: z.string().default(""),
  styleTextMutedColorDark: z.string().default(""),
  styleLinkColor: z.string().default(""),
  styleLinkColorDark: z.string().default(""),
  styleSurfaceColor: z.string().default(""),
  styleSurfaceColorDark: z.string().default(""),
  content: z.enum(teaserContentTypeValues).default("highlights"),
  limit: z.coerce.number().int().min(1).max(15).default(8),
})

export type LiveblogTeaserThemeConfiguration = z.infer<typeof rawLiveblogTeaserThemeConfigurationSchema>

export const liveblogTeaserThemeConfigurationSchema = z.preprocess(preprocessLiveblogTeaserThemeConfiguration, rawLiveblogTeaserThemeConfigurationSchema)

export const parsePartialLiveblogTeaserThemeConfiguration = createPartialParser<LiveblogTeaserThemeConfiguration>(rawLiveblogTeaserThemeConfigurationSchema, preprocessSharedThemeConfiguration)
